const RECEIPT_PREVIEW_STORAGE_KEY = 'receipt-preview';

export const RECEIPT_PREVIEW_PATH = '/meus-titulos/comprovante';

export type ReceiptPreview = {
  ticketId: string;
  html: string;
};

export const storeReceiptPreview = (preview: ReceiptPreview): boolean => {
  try {
    const storage = globalThis.sessionStorage;
    if (!storage || !preview.html) return false;

    const payload = JSON.stringify(preview);
    storage.setItem(RECEIPT_PREVIEW_STORAGE_KEY, payload);

    return storage.getItem(RECEIPT_PREVIEW_STORAGE_KEY) === payload;
  } catch {
    return false;
  }
};

export const readReceiptPreview = (): ReceiptPreview | null => {
  try {
    const raw = globalThis.sessionStorage?.getItem(RECEIPT_PREVIEW_STORAGE_KEY);
    if (!raw) return null;

    const parsed = JSON.parse(raw) as Partial<ReceiptPreview>;
    if (typeof parsed?.html !== 'string' || !parsed.html) return null;

    return { ticketId: parsed.ticketId ?? '', html: parsed.html };
  } catch {
    return null;
  }
};
